import { DefaultOptionType } from "antd/es/select";

// Função pura para normalizar strings
const normalizeString = (text: string): string => {
  return text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
};

// Hook que retorna a função de filtro
export const useNormalizedFilter = () => {
  return (input: string, option?: DefaultOptionType): boolean => {
    // Normaliza o termo de busca
    const searchTerm = normalizeString(input);

    // Normaliza o label e value da opção
    const optionLabel = normalizeString((option?.label as string) || "");
    const optionValue = normalizeString((option?.value as string) || "");

    // Retorna true se encontrou correspondência
    return optionLabel.includes(searchTerm) || optionValue.includes(searchTerm);
  };
};
